export const defaultEventImage = window.location.origin + "/assets/images/event-default.png";
